import { render, staticRenderFns } from "./dialog-uploadfiles.vue?vue&type=template&id=724fd124&"
import script from "./dialog-uploadfiles.vue?vue&type=script&lang=js&"
export * from "./dialog-uploadfiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports